import { useEffect } from "react";
import { _t } from "core/language";
import CDialog from "core/components/CDialog";
import Button from "core/components/form-controls/Button";
import { useCustomNavigate } from 'core/hooks/useCustomNavigate'
import { RouterName, route } from "core/router";
import { useAiChef, useResetAiChef } from "./../hooks/aiChef";
import useImagePicker, { useGetImagePicker } from "core/hooks/useImagePicker";
import AiChefPageWrapper from "./../components/AiChefPageWrapper";
import LoadingAI from "./../components/Loading";
import { AiChefTypeEnum } from './../store/types';
import {
  ImageTypeEnums,
} from 'core/store/upload/actions';
import { nl2br } from 'core/utils/helper';

const ImageRecipesLoadingPage = () => {
  const navigate = useCustomNavigate()
  const { onReset } = useResetAiChef()
  const aiChefImageRecipe = useGetImagePicker(
    'aiChefImageRecipe',
    false
  )
  const { handleButtonClick, handleRetryUpload } = useImagePicker({
    multiple: false,
    name: 'aiChefImageRecipe',
    property: ImageTypeEnums.TEMPORARY,
    openType: aiChefImageRecipe?.openType,
  })
  const {
    isBoth,
    setIsBoth,
    params,
    redirectTo,
    message,
    open,
    setOpen,
    retryUpload,
    lastPage,
    showLoading,
    updateRequestType,
  } = useAiChef(AiChefTypeEnum.meal, aiChefImageRecipe);

  useEffect(() => {
    if (typeof aiChefImageRecipe?.file === 'string') {
      onReset()
    }
  }, [aiChefImageRecipe?.file])

  const onCancel = () => {
    console.log('1111')
    onReset(false)
    navigate(lastPage)
  }

  useEffect(() => {
    (window as any)._nativeResponseFileCancel = () => {
      onCancel()
    }
  }, [onCancel])

  const handleSubmit = () => {
    setOpen(false)
    if (retryUpload) {
      handleRetryUpload()
      // onCancel()
    } else if (redirectTo) {
      return navigate(route(redirectTo))
    } else {
      onReset(false)
      handleButtonClick()
    }
  }

  return (
    <AiChefPageWrapper
      url={
        params.url || (
          typeof aiChefImageRecipe?.file === 'string' ? aiChefImageRecipe?.file : null
        )}
    >
      <div>
        {showLoading ? <LoadingAI /> : null}
      </div>
      <CDialog
        open={open}
        closeModal={() => setOpen(false)}
        onCancel={onCancel}
        handleSubmit={handleSubmit}
        // hideCancel={hideCancel}
        classNamechildren="px-[8px]"
        submitText={(retryUpload || message === 'unknow') ? _t('aiChef.retry') : _t('aiChef.yes')}
        closeText={(retryUpload || message === 'unknow') ? _t('aiChef.cancel') : _t('aiChef.no')}
        disableCloseOnBackDrop
      >
        <div className="w-full text-center">
          <p
            className="text-sm tracking-tighter"
            dangerouslySetInnerHTML={{__html: nl2br(_t(`aiChef.msg.${message}`))}}
          />
        </div>
      </CDialog>
      <CDialog
        open={isBoth}
        closeModal={() => setIsBoth(false)}
        classNamechildren="px-[8px]"
        isButton={false}
        onCancel={onCancel}
        disableCloseOnBackDrop
      >
        <div className="w-full text-center">
          <p
            className="text-sm tracking-tighter"
            dangerouslySetInnerHTML={{__html: nl2br(_t('aiChef.msg.bothType'))}}
          />
        </div>
        <div className="pt-[30px] w-full flex justify-center gap-2">
          <Button
            type="button"
            label={_t('aiChef.goToIngredient')}
            onClickBtn={() => {
              updateRequestType(AiChefTypeEnum.ingredient)
              navigate(route(RouterName.AI_CHEF_INGREDIENTS))
            }}
            size={'sm'}
            classBtn={`px-2`}
          />
          <Button
            type="button"
            label={_t('aiChef.goToRecipe')}
            onClickBtn={() => {
              updateRequestType(AiChefTypeEnum.meal)
              navigate(route(RouterName.AI_CHEF_RECIPES))
            }}
            size={'sm'}
            classBtn={`px-2`}
          />
        </div>
      </CDialog>
    </AiChefPageWrapper>
  );
};

export default ImageRecipesLoadingPage;
